import { isExperimentOn } from '@wix/domains-serverless-interface';
import { usePremiumEssentialsContext } from '@wix/premium-fed-sdk/@premium-essentials';
import { ExperimentSpecs } from '../constants';
import { usePreSuggestionsHidden } from './usePreSuggestionsQuery';
export const useGateRevamp = () => {
  const _ref = usePremiumEssentialsContext(false) ?? {},
    experiments = _ref.experiments;
  const isVariantArm = isExperimentOn(experiments == null ? void 0 : experiments[ExperimentSpecs.GateRevampWithSuggestions]);
  const preSuggestionsHidden = usePreSuggestionsHidden();
  const showsVariant = isVariantArm && !preSuggestionsHidden;
  return {
    isRevampedGate: preSuggestionsHidden || isVariantArm,
    iconOnlySearchButton: showsVariant,
    suggestionCardShadow: showsVariant,
    preSuggestionsHidden
  };
};
//# sourceMappingURL=useGateRevamp.js.map